import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

const env = createEnv({
  client: {
    VITE_API_URL: z.string().url(),
  },
  server: {
    SENTRY_AUTH_TOKEN: import.meta.env.DEV ? z.string().optional() : z.string(),
  },
  clientPrefix: "VITE_",
  runtimeEnv: import.meta.env,
});

export default env;
